export default "__VITE_ASSET__D_Ean8oa__"